/**
 * Animation Utilities
 * 
 * This file contains reusable animation keyframes and effects for the application.
 * These animations can be imported and used across different components.
 */

import { keyframes } from '@mui/system';

/**
 * Spinning animation for rotating elements
 */
export const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

/**
 * Pulse animation for subtle scaling effects
 */
export const pulseAnimation = keyframes`
  0% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 0.9; transform: scale(1.02); }
  100% { opacity: 0.6; transform: scale(1); }
`;

/**
 * Color shift animation for border colors
 */
export const colorShiftAnimation = keyframes`
  0% { border-color: rgba(187,134,252,0.7); }
  50% { border-color: rgba(3,218,198,0.7); }
  100% { border-color: rgba(187,134,252,0.7); }
`;

/**
 * Gradient rotation for background effects
 */
export const gradientRotation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

/**
 * Glow animation for transitions and highlights
 */
export const glowAnimation = keyframes`
  0% { box-shadow: 0 0 5px rgba(184, 187, 38, 0.3), 0 0 8px rgba(131, 165, 152, 0.3); }
  50% { box-shadow: 0 0 15px rgba(184, 187, 38, 0.5), 0 0 20px rgba(131, 165, 152, 0.5); }
  100% { box-shadow: 0 0 5px rgba(184, 187, 38, 0.3), 0 0 8px rgba(131, 165, 152, 0.3); }
`;

/**
 * Fade in animation for elements
 */
export const fadeIn = keyframes`
  0% { opacity: 0; }
  100% { opacity: 1; }
`;

/**
 * Slide in from bottom animation
 */
export const slideInFromBottom = keyframes`
  0% { transform: translateY(20px); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

/**
 * Slide in from left animation
 */
export const slideInFromLeft = keyframes`
  0% { transform: translateX(-20px); opacity: 0; }
  100% { transform: translateX(0); opacity: 1; }
`;

/**
 * Slide in from right animation
 */
export const slideInFromRight = keyframes`
  0% { transform: translateX(20px); opacity: 0; }
  100% { transform: translateX(0); opacity: 1; }
`;
